import config from 'global-variables';
import { useQuery } from 'react-query';
import { getToken } from './useLogin';
import { PendingOrder } from 'types/Orders';

async function getPendingOrders({ accountId }: { accountId?: string }): Promise<PendingOrder[]> {
    const token = getToken();
    if (!token) return [];
    const host = config.restAPIUrl;
    const res = await fetch(`${host}/orders/pending${accountId && accountId !== 'none' ? `/${accountId}` : ''}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });
    const data = await res.json();
    return data as PendingOrder[];
}

export function useGetPendingOrders(accountId: string) {
    return useQuery(['pending-orders', accountId], () => getPendingOrders({ accountId }), {
        refetchInterval: 0,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
}
